module.exports = {"getError":"Při načítání historie entit došlo k chybě"}